import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
    name: 'SberbankIcon',
    functional: true,
    render: function render(h, ctx) {
        return h("svg", _mergeJSXProps([{
            attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 85.34 82.075",
                fill: "currentColor",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            },
            "class": "feather"
        }, ctx.data]), [
            h("path", {
                attrs: {
                    d: "M 78.399 15.95 C 77.469 14.68 76.549 13.41 75.739 12.13 L 26.019 40.69 L 2.019 26.93 C 1.469 28.415 1.132 29.97 1.019 31.55 L 26.249 46.16 L 78.399 15.95 Z "
                }
            }),
            h("path", {
                attrs: {
                    d: "M 26.019 51.44 L 0.239 36.64 C 0.049 37.55 -0.029 38.481 0.009 39.41 C 0.009 62.973 19.111 82.075 42.674 82.075 C 66.238 82.075 85.339 62.973 85.339 39.41 C 85.387 32.659 83.802 25.996 80.719 19.99 L 26.019 51.44 Z "
                }
            }),
            h("path", {
                attrs: {
                    d: "M 72.269 8.55 C 71.054 7.403 69.779 6.322 68.449 5.31 L 26.019 29.94 L 5.559 18.26 C 4.869 19.53 4.169 20.92 3.359 22.42 L 25.789 35.37 L 72.269 8.55 Z "
                }
            }),
            h("path", {
                attrs: {
                    d: "M 64.289 2.54 C 62.684 1.579 61.013 0.73 59.289 0 L 26.019 19.16 L 11.109 10.75 C 10.109 11.75 9.109 13.06 8.109 14.33 L 25.909 24.51 L 64.289 2.54 Z "
                }
            })
        ]);
    }
};